import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "masterCheckbox"]

  connect() {
    this.updateCount()
    this.updateMaster()
  }

  toggle = (e) => {
    if (!this.hasMasterCheckboxTarget) {
      return
    }

    const checked = this.masterCheckboxTarget.checked

    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.disabled) return

      checkbox.checked = checked
    })

    this.updateCount()
  }

  updateCount() {
    const count = this.checkboxTargets.filter((target) => target.checked).length

    this.countTargets.forEach((target) => {
      target.innerText = count
    })
  }

  updateMaster() {
    if (!this.hasMasterCheckboxTarget) {
      return
    }

    this.masterCheckboxTarget.checked = this.checkboxTargets.every(
      (checkbox) => checkbox.checked || checkbox.disabled
    )
  }
}
